export default {
  title: 'Päivä ja aika',
  buttons: {
    done: 'Valmis',
  },
};
